import { useApi } from './api';

export interface Company {
  id: number;
  name: string;
}

export interface Board {
  id: number;
  name: string;
}

export interface PaginatedResponse<T> {
  has_more: boolean;
  [key: string]: any; // Additional fields depending on the type
}

export interface CompaniesResponse extends PaginatedResponse<Company> {
  companies: Company[];
}

export interface BoardsResponse extends PaginatedResponse<Board> {
  boards: Board[];
}

export const useFilterApi = () => {
  const { fetchWithAuth } = useApi();

  /**
   * Fetch companies with pagination and search
   * @param page Page number to fetch
   * @param search Optional search term
   * @returns Paginated list of companies
   */
  const fetchCompanies = async (page: number = 1, search: string = ''): Promise<CompaniesResponse> => {
    try {
      return await fetchWithAuth(
        `/api/companies?page=${page}&search=${encodeURIComponent(search)}`
      );
    } catch (error) {
      console.error('Error fetching companies:', error);
      return { companies: [], has_more: false };
    }
  };

  /**
   * Fetch boards with pagination and search
   * @param page Page number to fetch
   * @param search Optional search term
   * @returns Paginated list of boards
   */
  const fetchBoards = async (page: number = 1, search: string = ''): Promise<BoardsResponse> => {
    try {
      return await fetchWithAuth(
        `/api/boards?page=${page}&search=${encodeURIComponent(search)}`
      );
    } catch (error) {
      console.error('Error fetching boards:', error);
      return { boards: [], has_more: false };
    }
  };

  return {
    fetchCompanies,
    fetchBoards
  };
}; 